import React from 'react';
import styled from 'styled-components';

const SectionContainer = styled.div`
  padding: 80px 20px;
  display: flex;
  background-color:#062c3f;
  flex-direction: column;
  

  @media (min-width: 768px) {
    padding: 80px 110px;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const TextContainer = styled.div`
  max-width: 600px;
  margin-bottom: 40px;
  
  @media (min-width: 768px) {
    max-width: 50%;
    margin-right: 40px;
    margin-bottom: 0;
    text-align: left;
  }
`;

const Heading = styled.h2`
  font-size: 2.8em;
  font-weight: 700;
  line-height: 1.6;
  color: #fff;
  margin-bottom: 20px;

  span {
    color: #00cbf1;
  }
`;

const SubHeading = styled.p`
  font-size: 1.1em;
  color: #fff;
  line-height: 2.5;
  margin-bottom: 40px;
  text-align: justify;
  font-family: "Poppins", system-ui;
  font-weight: 400;
  font-style: normal;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  max-width: 50%;
`;

const BenefitCard = styled.div`
  padding: 25px 0px 25px 0px;
  text-align: left;
  width: 100%;

  @media (max-width: 480px) {
  width: 135%;
  }
`;

const IconContainer = styled.div`
  width: 70px;
  height: 70px;
  background-color: ${({ bgColor }) => bgColor || '#007bff'};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
`;

const Icon = styled.div`
  font-size: 28px;
  color: #06334b;
`;

const BenefitTitle = styled.h3`
  font-size: 22px;
  font-weight: 600;
  color: #00cbf1;
  margin-bottom: 10px;
`;

const BenefitDescription = styled.p`
  font-family: "Poppins", system-ui;
  font-style: normal;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  text-align: justify;
  line-height: 1.71;
`;

const BenefitsSection = () => {
  return (
    <SectionContainer>
      <TextContainer>
        <Heading>Why You Should Join Our <span>Awesome Team</span> </Heading>
        <SubHeading>
        Step into a world where your skills are nurtured, your ambitions are fueled, and your success is celebrated. Discover a career path that’s not just about work, but about passion, innovation, and making a real impact.
        </SubHeading>
      </TextContainer>

      <GridContainer>
        <BenefitCard>
          <IconContainer bgColor="#E7F2FF">
            <Icon><i className="fa-solid fa-users fa-xl"></i></Icon>
          </IconContainer>
          <BenefitTitle>Team Work</BenefitTitle>
          <BenefitDescription>
            Collaborate with skilled professionals in a supportive and dynamic environment.
          </BenefitDescription>
        </BenefitCard>

        <BenefitCard>
          <IconContainer bgColor="#FFEEED">
            <Icon><i className="fa-solid fa-arrow-trend-up fa-xl"></i></Icon>
          </IconContainer>
          <BenefitTitle>Upgrade Skills</BenefitTitle>
          <BenefitDescription>
            Enhance your expertise with the latest tools and technologies in your field.
          </BenefitDescription>
        </BenefitCard>


        <BenefitCard>
          <IconContainer bgColor="#F1F7E8">
            <Icon><i className="fa-solid fa-shield fa-xl"></i></Icon>
          </IconContainer>
          <BenefitTitle>Secured Future</BenefitTitle>
          <BenefitDescription>
            Benefit from our strong security measures and investment in your long-term success.
          </BenefitDescription>
        </BenefitCard>

        <BenefitCard>
          <IconContainer bgColor="#EFF2F5">
            <Icon><i className="fa-solid fa-graduation-cap fa-xl"></i></Icon>
          </IconContainer>
          <BenefitTitle>Training</BenefitTitle>
          <BenefitDescription>
            Access ongoing training and development to advance your career and skills.
          </BenefitDescription>
        </BenefitCard>

      
      </GridContainer>
    </SectionContainer>
  );
};

export default BenefitsSection;
